module.exports = __webpack_public_path__ + "static/media/break.93e1511e.svg";